import styled, { css } from 'styled-components';

import { fontFamily } from 'stylesheet';
import { colorUsage, fontSize, fontWeight, getSpacing, lineHeight } from 'stylesheetB2c';

export const Container = styled.div`
  position: relative;
  color: ${colorUsage.blackText};
  max-width: ${getSpacing(83)};
  text-align: center;
  font-family: ${fontFamily.bamOnline};
  font-weight: ${fontWeight.light};
  font-size: ${fontSize.XLarge};
  line-height: ${lineHeight.medium};
`;
Container.displayName = 'Container';

const arrowsCommonStyle = css`
  position: absolute;
  width: ${getSpacing(6)};
  top: -${getSpacing(6)};
`;

export const LeftArrow = styled.img`
  ${arrowsCommonStyle}
  left: -${getSpacing(9)};
`;
LeftArrow.displayName = 'LeftArrow';

export const RightArrow = styled.img`
  ${arrowsCommonStyle}
  right: -${getSpacing(9)};
  transform: rotate(80deg);
`;
RightArrow.displayName = 'RightArrow';
